import React from "react";

const footerStyle: React.CSSProperties = {
  backgroundColor: "#f8f9fa",
  color: "#6c757d",
  textAlign: "center",
  padding: "20px 0",
  marginTop: "auto",
  fontSize: "0.9rem",
  borderTop: "1px solid #e7e7e7",
};

const containerStyle: React.CSSProperties = {
  maxWidth: "960px",
  margin: "0 auto",
  padding: "0 15px",
};

const headingStyle: React.CSSProperties = {
  fontSize: "1rem",
  fontWeight: "bold",
  color: "#343a40",
  marginBottom: "10px",
};

const Footer: React.FC = () => {
  return (
    <footer style={footerStyle}>
      <div style={containerStyle}>
        <h4 style={headingStyle}>Wichtiger Hinweis</h4>
        <p>
          Dies ist ein Schulprojekt und dient ausschließlich zu Demonstrations-
          und Lernzwecken.
        </p>
        <p>
          <strong>
            Bitte verwenden Sie keine sensiblen, persönlichen oder realen Daten.
          </strong>{" "}
          Die Sicherheit der eingegebenen Informationen kann nicht garantiert
          werden.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
